<div class="flag" [ngClass]="color">
    <div class="shadow"></div>
    <h4 class="mb-0 fw-bold">{{text}}</h4>
</div>